import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import { userHasPermission } from "../../../../utils/accessTree";

const mesesOpts = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const currentYear = new Date().getFullYear();
const aniosOpts = [
  { label: currentYear, value: currentYear },
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear - 2, value: currentYear - 2 }
];

const tipoOperacionOpts = [
  { value: "VENTA_MEMBRESIA", label: "Venta" },
  { value: "REACTIVACION", label: "Reactivación" },
  { value: "INTEGRANTE_INDIVIDUAL", label: "Alta de integrante" }
];

export type Inputs = "mes" | "anio" | "tipoOperacion" | "idVendedor";
export type Buttons = "buscar" | "generarSnapshot";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: aniosOpts
      }
    },
    {
      name: "tipoOperacion",
      label: "Tipo Operación",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Todos",
        data: tipoOperacionOpts
      }
    },
    {
      name: "idVendedor",
      label: "Vendedor",
      bts: { mCol: 3 },
      component: IUserSelectorBuilder,
      props: {
        hidden: () => !userHasPermission(57201)
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      requiredIfNotFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda !== "factura" && !value,
        message: () => "El periodo es requerido"
      }
    },
    idVendedor: {
      requiredForPerm: {
        validator: value => userHasPermission(57201) && !value,
        message: () => "Seleccione al vendedor"
      }
    }
  },
  rows: [["mes", "anio", "tipoOperacion", "idVendedor", "buscar"]]
};
